import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import SelectInputBorder from 'components/commom/SelectInputBorder';
import MailIcon from 'assets/images/Dashboard/mail-request.svg';
import CallIcon from 'assets/images/Dashboard/call-request.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import { ClearTokenRedirectLogin } from 'utils/general';
import CommonToast from 'components/commom/CommonToast';
import Shimmer from 'components/commom/Shimmer';
import { getRevenueListCallAPI } from 'store/getRevenueStream/action';
import moment from 'moment';
import LabelWithInput from 'components/commom/LabelWithInput';
import RevenuePieChart from 'components/commom/PieChart';

const Revenue = () => {
  const { locale } = useContext(LocaleContext);
  const intl = useIntl();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const [formData, setFormData] = useState({
    type: 'All',
    startDate: '',
    endDate: '',
  });
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState({
    id: 'Today',
    name: 'Today',
  });

  const loading = useSelector((state) => state?.getRevenueListReducer?.loading);
  const renevueList = useSelector(
    (state) => state?.getRevenueListReducer?.users
  );

  const paymentType = [
    { id: 1, name: 'All' },
    { id: 2, name: 'Product Purchase' },
    { id: 3, name: 'Telemedicine' },
    { id: 4, name: 'Patient Subscription' },
    { id: 5, name: 'Doctor Subscription' },
  ];

  const selectDateList = [
    {
      id: 'Today',
      name: 'Today',
    },
    {
      id: 'Yesterday',
      name: 'Yesterday',
    },
    {
      id: 'Last 7 Days',
      name: 'Last 7 Days',
    },
    {
      id: 'Last 15 Days',
      name: 'Last 15 Days',
    },
    {
      id: 'Last 30 Days',
      name: 'Last 30 Days',
    },
    {
      id: 'Custom',
      name: 'Custom',
    },
  ];

  useEffect(() => {
    getRevenueList(
      'All',
      moment().format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    );
  }, []);

  const getRevenueList = (type, startDate, endDate) => {
    const data = `?start_date=${startDate}&end_date=${endDate}${type !== 'All' ? `&payment_type=${type}` : ''}`;
    const external = {
      run: true,
      handleFunction: () => {},
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };

    dispatch(getRevenueListCallAPI(data, external));
  };

  const handleChange = (event) => {
    const { name, value } = event?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value?.name,
    }));
    getRevenueList(value?.name, formData?.startDate, formData?.endDate);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (formData?.startDate && name === 'endDate') {
      getRevenueList(formData?.type, formData?.startDate, value);
    }
    if (formData?.endDate && name === 'startDate') {
      getRevenueList(formData?.type, value, formData?.endDate);
    }
  };

  const handleDateChange = (e) => {
    setSelectedDate(e?.target?.value);

    switch (e?.target?.value?.id) {
      case 'Today':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        getRevenueList(
          formData?.type,
          moment().format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        );
        break;

      case 'Yesterday':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(1, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        }));
        getRevenueList(
          formData?.type,
          moment().subtract(1, 'days').format('YYYY-MM-DD'),
          moment().subtract(1, 'days').format('YYYY-MM-DD')
        );
        break;

      case 'Last 7 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(6, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        getRevenueList(
          formData?.type,
          moment().subtract(6, 'days').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        );
        break;

      case 'Last 15 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(14, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        getRevenueList(
          formData?.type,
          moment().subtract(14, 'days').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        );
        break;

      case 'Last 30 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(29, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        getRevenueList(
          formData?.type,
          moment().subtract(29, 'days').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        );
        break;
      case 'Custom':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: '',
          ['endDate']: '',
        }));

      default:
        break;
    }
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainerrequest lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainerrequest lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0 pb-20">
            <FormattedMessage id="Revenue Stream" />
          </h2>
          {false ? (
            <Loader />
          ) : (
            <>
              <Row
                className="mt-3 mb-5 g-5"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <Col md={2} className="mt-4">
                  <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                    Type:
                  </div>
                  <div>
                    <SelectInputBorder
                      placeholder={intl.formatMessage({
                        id: 'type',
                      })}
                      name={'type'}
                      value={formData?.type}
                      data={paymentType}
                      onChange={(e) => handleChange(e)}
                      background={'#FFFFFF'}
                      colorIcon={'#292D32'}
                      placeholderColor={'#292D32'}
                    />
                  </div>
                </Col>
                <Col md={2} className="mt-4">
                  <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                    {'Select Date:'}
                  </div>
                  <div>
                    <SelectInputBorder
                      placeholder={intl.formatMessage({
                        id: 'Select Date',
                      })}
                      name={'selectDate'}
                      value={selectedDate?.id || ''}
                      data={selectDateList}
                      onChange={(e) => handleDateChange(e)}
                      background={'#FFFFFF'}
                      colorIcon={'#292D32'}
                      placeholderColor={'#292D32'}
                    />
                  </div>
                </Col>
                {selectedDate?.id === 'Custom' && (
                  <>
                    <Col md={2} className="mt-2">
                      <div>
                        <LabelWithInput
                          label="Start Date"
                          type="date"
                          name="startDate"
                          value={formData?.startDate}
                          disabled={false}
                          onChange={(e) => {
                            handleInputChange(e);
                          }}
                        />
                      </div>
                    </Col>
                    <Col md={2} className="mt-2">
                      <div>
                        <LabelWithInput
                          label="End Date"
                          type="date"
                          name="endDate"
                          value={formData?.endDate}
                          disabled={false}
                          onChange={(e) => {
                            handleInputChange(e);
                          }}
                        />
                      </div>
                    </Col>
                  </>
                )}
              </Row>
              {loading ? (
                <Loader />
              ) : (
                <>
                  <Row className="mt-4 g-4">
                    <Col lg={4} xl={3} md={6} sm={12}>
                      <Card
                        className={locale === 'en' ? 'text-start' : 'text-end'}
                      >
                        <Card.Body>
                          <div className="flex justify-between">
                            <div>
                              <div className="fs-20 fc-292D32 lh-201 family_outfit_semiBold_600">
                                <FormattedMessage id="Total Earnings" />
                              </div>
                              <div className="pt-8 fs-16 lh-3528 fc-3C3C3C family_outfit_regular_500">
                                {false ? (
                                  <Shimmer
                                    width="250px"
                                    height="20px"
                                    marginTop="8px"
                                  />
                                ) : (
                                  <div className="mt-[10px]">
                                    <div>
                                      Amount:{' '}
                                      {renevueList?.data?.total_earnings?.amount?.toFixed(
                                        2
                                      )}{' '}
                                    </div>
                                    <div>
                                      Count:{' '}
                                      {renevueList?.data?.total_earnings?.count}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={4} xl={3} md={6} sm={12}>
                      <Card
                        className={locale === 'en' ? 'text-start' : 'text-end'}
                      >
                        <Card.Body>
                          <div className="flex justify-between">
                            <div>
                              <div className="fs-20 fc-292D32 lh-201 family_outfit_semiBold_600">
                                <FormattedMessage id="Telemedicine Earnings" />
                              </div>
                              <div className="pt-8 fs-16 lh-3528 fc-3C3C3C family_outfit_regular_500">
                                {false ? (
                                  <Shimmer
                                    width="250px"
                                    height="20px"
                                    marginTop="8px"
                                  />
                                ) : (
                                  <div className="mt-[10px]">
                                    <div>
                                      Amount:{' '}
                                      {renevueList?.data?.telemedicine_earnings?.amount?.toFixed(
                                        2
                                      )}
                                    </div>
                                    <div>
                                      Count:{' '}
                                      {
                                        renevueList?.data?.telemedicine_earnings
                                          ?.count
                                      }
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={4} xl={3} md={6} sm={12}>
                      <Card
                        className={locale === 'en' ? 'text-start' : 'text-end'}
                      >
                        <Card.Body>
                          <div className="flex justify-between">
                            <div>
                              <div className="fs-20 fc-292D32 lh-201 family_outfit_semiBold_600">
                                <FormattedMessage id="User Subscriptions" />
                              </div>
                              <div className="pt-8 fs-16 lh-3528 fc-3C3C3C family_outfit_regular_500">
                                {false ? (
                                  <Shimmer
                                    width="250px"
                                    height="20px"
                                    marginTop="8px"
                                  />
                                ) : (
                                  <div className="mt-[10px]">
                                    <div>
                                      Amount:{' '}
                                      {renevueList?.data?.user_subscriptions?.amount?.toFixed(
                                        2
                                      )}
                                    </div>
                                    <div>
                                      Count:{' '}
                                      {
                                        renevueList?.data?.user_subscriptions
                                          ?.count
                                      }
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={4} xl={3} md={6} sm={12}>
                      <Card
                        className={locale === 'en' ? 'text-start' : 'text-end'}
                      >
                        <Card.Body>
                          <div className="flex justify-between">
                            <div>
                              <div className="fs-20 fc-292D32 lh-201 family_outfit_semiBold_600">
                                <FormattedMessage id="Doctor Subscriptions" />
                              </div>
                              <div className="pt-8 fs-16 lh-3528 fc-3C3C3C family_outfit_regular_500">
                                {false ? (
                                  <Shimmer
                                    width="250px"
                                    height="20px"
                                    marginTop="8px"
                                  />
                                ) : (
                                  <div className="mt-[10px]">
                                    <div>
                                      Amount:{' '}
                                      {renevueList?.data?.doctor_subscriptions?.amount?.toFixed(
                                        2
                                      )}
                                    </div>
                                    <div>
                                      Count:{' '}
                                      {
                                        renevueList?.data?.doctor_subscriptions
                                          ?.count
                                      }
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={4} xl={3} md={6} sm={12}>
                      <Card
                        className={locale === 'en' ? 'text-start' : 'text-end'}
                      >
                        <Card.Body>
                          <div className="flex justify-between">
                            <div>
                              <div className="fs-20 fc-292D32 lh-201 family_outfit_semiBold_600">
                                <FormattedMessage id="Product Purchases" />
                              </div>
                              <div className="pt-8 fs-16 lh-3528 fc-3C3C3C family_outfit_regular_500">
                                {false ? (
                                  <Shimmer
                                    width="250px"
                                    height="20px"
                                    marginTop="8px"
                                  />
                                ) : (
                                  <div className="mt-[10px]">
                                    <div>
                                      Amount:{' '}
                                      {renevueList?.data?.product_purchases?.amount?.toFixed(
                                        2
                                      )}
                                    </div>
                                    <div>
                                      Count:{' '}
                                      {
                                        renevueList?.data?.product_purchases
                                          ?.count
                                      }
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  {renevueList?.data?.total_earnings?.count > 0 && (
                    <div className="my-[30px]">
                      <RevenuePieChart
                        data={[
                          {
                            name: 'Doctor Subscriptions',
                            amount:
                              renevueList?.data?.doctor_subscriptions?.amount,
                            count:
                              renevueList?.data?.doctor_subscriptions?.count,
                          },
                          {
                            name: 'User Subscriptions',
                            amount:
                              renevueList?.data?.user_subscriptions?.amount,
                            count: renevueList?.data?.user_subscriptions?.count,
                          },
                          {
                            name: 'Telemedicine Earnings',
                            amount:
                              renevueList?.data?.telemedicine_earnings?.amount,
                            count:
                              renevueList?.data?.telemedicine_earnings?.count,
                          },
                          {
                            name: 'Product Purchases',
                            amount:
                              renevueList?.data?.product_purchases?.amount,
                            count: renevueList?.data?.product_purchases?.count,
                          },
                        ]}
                      />
                    </div>
                  )}
                  <div className="pt-20 mb-[50px]">
                    <Row className="listCustomHeader m-0 p-0 flex items-center">
                      <Col lg={3} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                          <FormattedMessage id="Patient & ID" />
                        </p>
                      </Col>
                      <Col lg={3} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                          <FormattedMessage id="Contact Info" />
                        </p>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                          <FormattedMessage id="Payment Type" />
                        </p>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                          <FormattedMessage id="Amount" />
                        </p>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                          <FormattedMessage id="Amount Type" />
                        </p>
                      </Col>
                    </Row>
                    {renevueList?.data?.revenue_details?.length > 0 ? (
                      <Row className="m-0 p-0">
                        {renevueList?.data?.revenue_details.map(
                          (item, index) => {
                            return (
                              <Row className="m-0 p-0 flex items-center listAppointment">
                                <Col lg={3} md={6} sm={12}>
                                  <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                                    {item?.paid_by?.full_name}
                                  </div>
                                  <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                                    {item?.paid_by?.patient_id}
                                  </div>
                                </Col>
                                <Col lg={3} md={6} sm={12}>
                                  <Stack
                                    direction="horizontal"
                                    gap={2}
                                    className="items-center "
                                  >
                                    <img src={MailIcon} alt="icon" />
                                    <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all ...">
                                      {item?.paid_by?.email}
                                    </div>
                                  </Stack>
                                  <Stack
                                    direction="horizontal"
                                    gap={2}
                                    className="items-center pt-04"
                                  >
                                    <img src={CallIcon} alt="icon" />
                                    <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                                      {item?.paid_by?.country_code}
                                      {item?.paid_by?.contact_number}
                                    </div>
                                  </Stack>
                                </Col>
                                <Col lg={2} md={6} sm={12}>
                                  <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                                    {item?.payment_type}
                                  </div>
                                </Col>
                                <Col lg={2} md={6} sm={12}>
                                  <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                                    {item?.amount}
                                  </div>
                                </Col>
                                <Col lg={2} md={6} sm={12}>
                                  <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                                    {item?.amount_type}
                                  </div>
                                </Col>
                              </Row>
                            );
                          }
                        )}
                      </Row>
                    ) : (
                      <div className="flex justify-center pt-120">
                        <div>
                          <Image src={EmptyScreen} alt="icon" />
                          <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                            Nothing here yet
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Revenue;
